// This file can be used to export Angular providers for the extension
// The component is declared in seller-brands.module.ts and registered through the shared module
export default [];
